<section
  class="getting-numbers-right"
  data-testid="getting-numbers-right-section"
>
  <goab-text tag="h1" size="heading-xl" mt="xl" mb="s">
    Getting the numbers right: how to fill out the form
  </goab-text>

  <goab-text tag="p" size="body-m" mt="none" mb="m">
    Please review this section to help ensure your reporting is consistent, even
    if you have filled out the form many times. Your reporting helps Assisted
    Living Alberta better understand capacity across the system.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s">
    Occupied beds: filled beds, matched beds and referral assessments
  </goab-text>
  <goab-text tag="span" size="body-m" mt="none" mb="m">
    Include all beds currently occupied by a resident, as well as matched beds
    where an admission is pending or referral under assessment.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="m">
    These beds are not available for referral but would be if a resident was
    discharged or a referral was not accepted.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s">
    Operational beds: beds open for referral and occupied filled beds, matched
    beds and referral assessments
  </goab-text>
  <goab-text tag="span" size="body-m" mt="none" mb="m">
    Operational beds include all occupied beds, plus all beds vacant and open
    for new referrals. This includes short-term maintenance that does not limit
    referrals.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="m">
    Non-operational beds are beds that are empty but not eligible for referrals.
    Beds may be closed because of staffing issues, outbreak management,
    long-term maintenance that prevents availability, an emergency or other
    operational reason.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="m">
    Additionally, a bed would be non-operational if filled by a lodge resident
    when no ALA referral was made.
  </goab-text>
  <goab-text tag="p" size="body-m" mt="none" mb="m">
    Please choose the relevant reasons that appear if you have operational bed
    changes.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s">
    Vacancy: beds open for new referrals
  </goab-text>
  <goab-text tag="span" size="body-m" mt="none" mb="m">
    Should show the number of beds that are open for a referral from Assisted
    Living Alberta when your report. Vacancy is calculated from the difference
    between occupied and operational beds at the time of reporting.
  </goab-text>

  <goab-text tag="h2" size="heading-xs" mt="xl" mb="s"> Funded beds </goab-text>
  <goab-text tag="span" size="body-m" mt="none" mb="3xl">
    The maximum number of beds on contract with Assisted Living Alberta.
  </goab-text>
</section>
